export const environment = {
  production: false,
  baseUrl: 'https://rda-dev.itehk-services.com',
  apiUrl: 'https://rda-dev.itehk-services.com/api',
  secretKey: ''
}
